/* ========================================================================
 * Meganav
 *
 * Handles both mobile and desktop functionality
 * ======================================================================== */

import { Constants } from "./constants";
import Toolbox from "./toolbox";
import $ from "jquery";


const openDuration = 300;
const closeDuration = 300;

class MegaNav {

	// When any new sub level is opened, any currently open sublevel(s) are folded.
	static closeSubLevels($elem) {
		$elem.find(".meganav-dropdown .mobile-sublevel-flip").removeClass(
			"mobile-sublevel-flip"
		);
		$elem.find(
			".meganav-dropdown:not(.brands) .dd-link:visible, .meganav-dropdown:not(.brands) .dd-link-all:visible"
		).slideUp(closeDuration);
	}

	// When menu headlines are changed to fold a sub level, the link functionality has to be removed.
	static preventA(e) {
		e.preventDefault();
	}

	init() {
		let $megaNavDesktop = false;
		let $megaNavMobile = false;
		var toggleContainer = $(".tiny-header");
		const $megaNav = $(".meganav .meganav-main");
		if ($megaNav.length > 0) {
			$megaNavDesktop = $megaNav.clone();
			$megaNavDesktop.addClass("nav-desktop");
			$megaNavMobile = $megaNav.clone();
			$megaNavMobile.addClass("nav-mobile");
		} else {
			return false;
		}

		var dropdownArrow = $(".icon-arrow-down:first")
			.clone()
			.addClass("mobile-sublevel-icon");

		//Open off canvas elements
		toggleContainer.on("click", ".mobile-toggle", function (e) {
			e.preventDefault();

			var target = $($(this).data("toggle-target"));

			$(".mobile-offcanvas")
				.not(target)
				.removeClass("open");

			target.toggleClass("open");
		});

		//Close off canvas elements
		$(".close-mobile-offcanvas").on("click", function (e) {
			$(this)
				.closest(".mobile-offcanvas")
				.removeClass("open");
		});

		function processMobileMenu() {

			const $megaNavMobileClone = $megaNavMobile.clone();

			const $mobileNavLink = $megaNavMobileClone.find(".has-children > a");

			$megaNavMobileClone.find(".meganav-dropdown .dd-link-all").each(function () {
				// The "all somethings" link is at the bottom of the ul, but it needs to be the first link.
				var parent = $(this).parent(); // ul root
				$(this)
					.detach()
					.prependTo(parent); // pull it from the end and insert it back on top. That's what she said.
			});

			$megaNavMobileClone.find(".meganav-dropdown .dd-title").each(function () {
				var ddTitle = $(this).clone();

				var ddTitleA = ddTitle.find("a");
				// By the way this is super hacky and I don't like it one bit. But it works for the moment...

				const hrefValue = ddTitleA.attr("href");
	
				// Do not add links for pages that don't exist.
				if (hrefValue && hrefValue !== "/") {
					ddTitleA.text("Kaikki " + ddTitleA.text().toLowerCase() + "tuotteet");
					ddTitle.toggleClass("dd-title dd-link").insertAfter(this); // dd-title is switched off, dd-link is switched on
				}
				
			});

			$megaNavMobileClone.find(".dd-title, .dropdown-title").each(function () {
				// The folding indicator is cloned to all sub level headings
				$(dropdownArrow)
					.clone()
					.appendTo(this);
			});

			// Menu Top level folding
			$mobileNavLink.on("click", (e) => {
				//Toggle childrens' visibility on mobile
				MegaNav.preventA(e); // Link shouldn't fire, user is folding the menu
				MegaNav.closeSubLevels($megaNavMobileClone);
				// Check if this level is already open? No need to reopen it again after closing open level
				const elem = e.target;
				var isTopLevelVisible = $(elem)
					.siblings(".meganav-dropdown")
					.is(":visible");
				$(".meganav-dropdown:visible").slideToggle(openDuration); // Collapse previously open menu
				if (!isTopLevelVisible) {
					$(elem)
						.siblings(".meganav-dropdown")
						.slideToggle(openDuration); // roll out clicked menu
					// Instead of simply calling toggleClass, add/remove are used, because there's some issue with the underlying jQuery dropdown code, and this takes care of it
					$(".meganav-main.nav-mobile .primary-item.open").removeClass("open");
					$(elem)
						.parent()
						.addClass("open"); // What the open class does is it spins the folding indicator ^ upside down when the menu is opened.
				} else {
					$(elem)
						.parent()
						.removeClass("open");
				}
			});

			// Menu Sub level folding
			// .clothes & .shoes
			$mobileNavLink.each(function () {
				// Collapse all descendants
				$(this)
					.parent()
					.find(".meganav-dropdown:not(.sports, .brands, .categories) .row ul li")
					.hide();

				// bind menu folding functions to headings
				$(this)
					.parent()
					.find(".row :not(.all-categories) p.dropdown-title")
					.on("click", function (e) {
						// Check if the clicked sublevel is already open. If it is, it shouldn't be opened again, instead it will remain closed
						var isSubLevelVisible = $(this)
							.parent()
							.find("ul li")
							.is(":visible");
						MegaNav.closeSubLevels($megaNavMobileClone);
						if (!isSubLevelVisible) {
							$(this)
								.find(".mobile-sublevel-icon")
								.addClass("mobile-sublevel-flip");
							$(this)
								.parent()
								.find("ul li")
								.slideDown(openDuration);
						}
					});
				// In mobile menu mode the title works as a menu folding button, so the link needs to be suppressed
				$(this)
					.parent()
					.find(".row p.dropdown-title a")
					.on("click", MegaNav.preventA);
			});

			// .sports
			// Collapse all descendants
			$megaNavMobileClone.find(".meganav-dropdown.sports")
				.find(".row .dd-link")
				.hide();
			$megaNavMobileClone.find(".meganav-dropdown.sports .dd-title").on("click", function (e) {
				// Check if the clicked sublevel is already open. If it is, we don't open it again, instead it will remain closed
				var isSubLevelVisible = $(this).next(":visible").length;
				MegaNav.closeSubLevels($megaNavMobileClone);
				if (!isSubLevelVisible) {
					// ...then we don't reopen them after closing
					$(this)
						.find(".mobile-sublevel-icon")
						.addClass("mobile-sublevel-flip");
					$(this)
						.nextUntil(".dd-title")
						.slideDown(openDuration);
				}
			});
			// In mobile menu mode the title works as a menu folding button, so the link needs to be suppressed
			$megaNavMobileClone.find(".meganav-dropdown.sports .dd-title a").on("click", MegaNav.preventA);

			// .sports .all-categories
			$megaNavMobileClone.find(".meganav-dropdown .all-categories .dropdown-title").on("click", function (e) {
				// Check if the clicked sublevel is already open. If it is, we don't open it again, instead it will remain closed
				var isSubLevelVisible = $(this)
					.parent()
					.find(".categories li.dd-link:visible").length;
				MegaNav.closeSubLevels($megaNavMobileClone);
				if (!isSubLevelVisible) {
					$(this)
						.find(".mobile-sublevel-icon")
						.addClass("mobile-sublevel-flip");
					$(this)
						.parent()
						.find(".categories li.dd-link")
						.slideDown(openDuration);
				}
			});

			$megaNavMobileClone.find(".primary-item.selected > a").trigger("click");

			// .shoes or .clothes is selected
			var shoesClothes = $megaNavMobileClone.find(
				".meganav-dropdown.clothes a.selected, .meganav-dropdown.shoes a.selected"
			);
			if (shoesClothes.length) {
				$(shoesClothes)
					.closest("div")
					.find("p.dropdown-title")
					.trigger("click");
			}

			// .sports is selected
			var sports = $megaNavMobileClone.find(".meganav-dropdown.sports a.selected");
			if (sports.length) {
				$(sports)
					.parent()
					.prevAll(".dd-title")
					.find("a")
					.trigger("click");
			}

			// .categories is selected
			var categories = $megaNavMobileClone.find(".meganav-dropdown .all-categories a.selected");
			if (categories.length) {
				$megaNavMobileClone.find(".meganav-dropdown .all-categories .dropdown-title").trigger("click");
			}

			return $megaNavMobileClone;
		}


		swapNawMenu();

		function swapNawMenu() {
			const $megaNav = $(".meganav .meganav-main");
			if ($megaNav.length > 0) {
				const width = window.innerWidth || document.documentElement.clientWidth ||
					document.body.clientWidth;
				/* const height = window.innerHeight || document.documentElement.clientHeight ||
					document.body.clientHeight; */
				const isMobile = Constants.screenSizes.screenSmMx > width;
				if (!$megaNav.hasClass("nav-mobile") && isMobile) {
					$(".meganav .meganav-main").replaceWith(processMobileMenu());
				} else if (!$megaNav.hasClass("nav-desktop") && !isMobile) {
					$(".meganav .meganav-main").replaceWith(processDesktopMenu());
				}
			}
		}


		window.addEventListener("resize", () => {
			Toolbox.waitForFinalEvent(() => {
				swapNawMenu();
			}, 500, "navResizeHelper");
		});



		function processDesktopMenu() {
			const $megaNavDesktopClone = $megaNavDesktop.clone();
			var $navItem = $megaNavDesktopClone.find(".has-children");
			var hoverTimer;
			// Desktop
			$navItem.on("mouseover", function (e) {
				clearTimeout(hoverTimer);

				var $item = $(this);
				if ($item.hasClass("open")) {
					return false;
				}

				if ($navItem.hasClass("open")) {
					openMenu($item);
				} else {
					hoverTimer = setTimeout(function () {
						openMenu($item);
					}, 200);
				}
			});
			// Desktop
			$navItem.on("mouseout", function (e) {
				if (!$(e.toElement).closest($navItem).length) {
					clearTimeout(hoverTimer);
					hoverTimer = setTimeout(function () {
						hideMenu();
					}, 200);
				}
			});

			function openMenu($item) {
				$navItem.removeClass("open");
				$item.addClass("open");
			}

			function hideMenu() {
				$navItem.removeClass("open");
			}

			return $megaNavDesktopClone;

		}
	}

}

export default new MegaNav();